/**
 * Created by emhaje-workspace on 5/16/17.
 */
import {rupiah} from 'utils/formatter'
import styles from './PurchaseItemList.css'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import _ from 'lodash'

const popoverFocus = ({content}) => (
  <Popover id='purchaseOrder'>
    {content}
  </Popover>
)

class PurchaseItemList extends React.Component {
  render () {
    const {detail = [], total, isIngredient} = this.props
    var result = _.chain(detail)
      .groupBy('item_id')
      .map(function (currentItem) {
        return currentItem
      })
      .value()
    return (<div>
      {!isIngredient && <div>
        {result.map((hai) => {
          if (hai.length > 1) {
            return (<div className={`col-md-12 ${styles.item}`}>
              <div className={`col-md-2 text-center ${styles.itemHeader}`}>VARIANT</div>
              <div className={`col-md-2 text-center ${styles.itemHeader}`}>IN STOCK</div>
              <div className={`col-md-2 text-center ${styles.itemHeader}`}>ORDER</div>
              <div className={`col-md-3 text-center ${styles.itemHeader}`}>UNIT COST</div>
              <div className={`col-md-3 text-center ${styles.itemHeader}`}>TOTAL</div>
              <div className={`col-md-12 ${styles.padding0}`}><input
                className={`form-control text-center ${styles.itemDetailUp}`} value={hai[0].item_name} disabled /></div>
              { hai.map((each, index) => {
                return (<div className={`col-md-12 ${styles.padding0}`}>
                  <OverlayTrigger placement='top' overlay={popoverFocus({content: each.item_variant_name})}>
                    <div className={`col-md-2 ${styles.padding0}`}><input
                      className={`form-control ${index === hai.length - 1 ? styles.itemDetailLeftDown : styles.itemDetail}`} value={each.item_variant_name} disabled /></div>
                  </OverlayTrigger>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetailBeginingStock}`} value={each.beginning_stock} disabled /></div>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={each.quantity} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={rupiah(each.price)} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${index === hai.length - 1 ? styles.itemDetailRightDown : styles.itemDetail}`} value={rupiah(each.price * each.quantity)} disabled />
                  </div>
                </div>)
              })}
            </div>)
          } else {
            let each = hai[0]
            if (each.item_variant_name) {
              return (<div className={`col-md-12 ${styles.item}`}>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>VARIANT</div>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>IN STOCK</div>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>ORDER</div>
                <div className={`col-md-3 text-center ${styles.itemHeader}`}>UNIT COST</div>
                <div className={`col-md-3 text-center ${styles.itemHeader}`}>TOTAL</div>
                <div className={`col-md-12 ${styles.padding0}`}><input
                  className={`form-control text-center ${styles.itemDetailUp}`} value={hai[0].item_name} disabled /></div>
                <div className={`col-md-12 ${styles.padding0}`}>
                  <OverlayTrigger placement='top' overlay={popoverFocus({content: each.item_variant_name})}>
                    <div className={`col-md-2 ${styles.padding0}`}><input
                      className={`form-control ${styles.itemDetailLeftDown}`} value={each.item_variant_name} disabled /></div>
                  </OverlayTrigger>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetailBeginingStock}`} value={each.beginning_stock} disabled /></div>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={each.quantity} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={rupiah(each.price)} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetailRightDown}`} value={rupiah(each.price * each.quantity)} disabled />
                  </div>
                </div>
              </div>)
            } else {
              return (<div className={`col-md-12 ${styles.item}`}>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>ITEM</div>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>IN STOCK</div>
                <div className={`col-md-2 text-center ${styles.itemHeader}`}>ORDER</div>
                <div className={`col-md-3 text-center ${styles.itemHeader}`}>UNIT COST</div>
                <div className={`col-md-3 text-center ${styles.itemHeader}`}>TOTAL</div>
                <div className={`col-md-12 ${styles.padding0}`}>
                  <OverlayTrigger placement='top' overlay={popoverFocus({content: each.item_name})}>
                    <div className={`col-md-2 ${styles.padding0}`}><input
                      className={`form-control ${styles.itemDetailLeft}`} value={each.item_name} disabled /></div>
                  </OverlayTrigger>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetailBeginingStock}`} value={each.beginning_stock} disabled /></div>
                  <div className={`col-md-2 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={each.quantity} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetail}`} value={rupiah(each.price)} disabled /></div>
                  <div className={`col-md-3 ${styles.padding0}`}><input
                    className={`form-control ${styles.itemDetailRight}`} value={rupiah(each.price * each.quantity)} disabled />
                  </div>
                </div>
              </div>)
            }
          }
        })}
      </div>}
      { isIngredient && <div> {detail.map((ingredient) => {
        return (<div className={`col-md-12 ${styles.item}`}>
          <div className={`col-md-2 text-center ${styles.itemHeader}`}>UNIT</div>
          <div className={`col-md-2 text-center ${styles.itemHeader}`}>IN STOCK</div>
          <div className={`col-md-2 text-center ${styles.itemHeader}`}>ORDER</div>
          <div className={`col-md-3 text-center ${styles.itemHeader}`}>UNIT COST</div>
          <div className={`col-md-3 text-center ${styles.itemHeader}`}>TOTAL</div>
          <div className={`col-md-12 ${styles.padding0}`}><input
            className={`form-control text-center ${styles.itemDetailUp}`} value={ingredient.ingredient_name} disabled /></div>
          <div className={`col-md-12 ${styles.padding0}`}>
            <OverlayTrigger placement='top' overlay={popoverFocus({content: ingredient.unit_name})}>
              <div className={`col-md-2 ${styles.padding0}`}><input
                className={`form-control ${styles.itemDetailLeftDown}`} value={ingredient.unit_name} disabled /></div>
            </OverlayTrigger>
            <div className={`col-md-2 ${styles.padding0}`}><input
              className={`form-control ${styles.itemDetailBeginingStock}`} value={ingredient.beginning_stock} disabled /></div>
            <div className={`col-md-2 ${styles.padding0}`}><input
              className={`form-control ${styles.itemDetail}`} value={ingredient.quantity} disabled /></div>
            <div className={`col-md-3 ${styles.padding0}`}><input
              className={`form-control ${styles.itemDetail}`} value={rupiah(ingredient.unit_price)} disabled /></div>
            <div className={`col-md-3 ${styles.padding0}`}><input
              className={`form-control ${styles.itemDetailRightDown}`} value={rupiah(ingredient.unit_price * ingredient.quantity)} disabled />
            </div>
          </div>
        </div>)
      })}
        </div>}
      <div>
        <div className='pull-left'>TOTAL</div>
        <div className='text-right'>{rupiah(total)}</div>
      </div>
    </div>
    )
  }
}

export default PurchaseItemList



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrderDetail/PurchaseItemList/PurchaseItemList.js